(() => {
  const page = document.querySelector('.lx-policy');
  const body = page?.querySelector('.shopify-policy__body .rte');
  if (!body) return;

  const select = page.querySelector('#lx-policy-section');
  const directory = page.querySelector('.lx-policy__directory');
  if (matchMedia('(max-width: 760px)').matches) directory.open = false;

  const cover = body.querySelector('p');
  if (cover?.firstChild?.textContent.trim() === 'LUXSOL LTD' && cover.querySelectorAll('br').length === 4) {
    // Style the existing cover lines without transcribing the contract or changing their order.
    const lines = Array.from(cover.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
    if (lines.length === 4) {
      cover.classList.add('lp-document');
      for (const node of lines) {
        const line = document.createElement('span');
        node.replaceWith(line);
        line.append(node);
      }
    }
  }

  // Imported policies use both native headings and upper-case paragraphs for sections.
  for (const element of body.querySelectorAll('p, h2, h3, h4, h5')) {
    const label = element.textContent.trim().replace(/\s+/g, ' ');
    if (!label && !element.querySelector('img, video, svg, iframe, input, a[id]')) {
      element.classList.add('lp-blank');
      continue;
    }
    const delivery = label === 'Delivery safety';
    const importedHeading = !element.querySelector('br') && /^[A-Z][A-Z\s&‘’()–-]{2,90}$/.test(label);
    if (!delivery && !importedHeading && element.tagName === 'P') continue;

    if (delivery) element.closest('li')?.classList.add('lp-delivery');
    else element.classList.add('lp-chapter');
    if (element.tagName === 'P') {
      element.classList.add('lp-subhead');
      element.setAttribute('role', 'heading');
      element.setAttribute('aria-level', delivery ? '3' : '2');
    }
    if (!element.id) {
      const base = 'policy-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '');
      let id = base;
      let n = 1;
      while (document.getElementById(id)) id = base + '-' + ++n;
      element.id = id;
    }
    select.add(new Option(label, element.id));
  }
  if (select.options.length > 2) {
    select.parentElement.hidden = false;
    select.addEventListener('change', () => {
      const heading = document.getElementById(select.value);
      if (!heading) return;
      location.hash = heading.id;
      heading.tabIndex = -1;
      heading.focus({preventScroll:true});
    });
  }
})();
